(() => {
  if (document.documentElement.lang !== 'ar') return;

  const excluded = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'OPTION']);
  const pattern = /\bQAR\s*([0-9][0-9.,]*)/g;
  const duplicateCurrencyLabel = /(?:QAR[\s\u00a0]*ر\.ق|ر\.ق[\s\u00a0]*QAR)/g;

  const localize = (root) => {
    if (!root || excluded.has(root.nodeName)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement && excluded.has(node.parentElement.tagName)) continue;
      if (pattern.test(node.data)) node.data = node.data.replace(pattern, '$1 ر.ق');
      pattern.lastIndex = 0;
      if (duplicateCurrencyLabel.test(node.data)) node.data = node.data.replace(duplicateCurrencyLabel, 'ر.ق');
      duplicateCurrencyLabel.lastIndex = 0;
    }
  };

  const start = () => {
    localize(document.body);
    const observer = new MutationObserver((records) => {
      for (const record of records) {
        if (record.type === 'characterData') localize(record.target.parentElement);
        for (const node of record.addedNodes) {
          if (node.nodeType === Node.TEXT_NODE) localize(node.parentElement);
          if (node.nodeType === Node.ELEMENT_NODE) localize(node);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
